import { render, staticRenderFns } from "./AboutUsView.vue?vue&type=template&id=8b2cab9e"
import script from "./AboutUsView.vue?vue&type=script&lang=js"
export * from "./AboutUsView.vue?vue&type=script&lang=js"
import style0 from "./AboutUsView.vue?vue&type=style&index=0&id=8b2cab9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports